import { removeUndefinedAttributes } from '../removeUndefinedAttributes';
import { getFrontendEventRouterUrl } from './getFrontendEventRouterUrl';
import trackerFactory from './trackerFactory';
export const configureTracker = ({ config, trackerClient, extraTrackingData, locale, }) => {
    const { version, environment, sessionId } = config;
    const tracker = trackerFactory(trackerClient);
    const trackingData = removeUndefinedAttributes({
        clientId: extraTrackingData?.clientId,
        accountId: extraTrackingData?.accountId,
        additionalIdentifier: extraTrackingData?.additionalIdentifier,
        sdk: 'websdk',
        aId: extraTrackingData?.aId,
    });
    tracker.configure({
        options: {
            client: trackerClient,
            clientVersion: version,
            sessionId,
            baseUrl: getFrontendEventRouterUrl({ environment, locale }),
        },
        data: trackingData,
    });
    return tracker;
};
